const CART_CONFIG = {
  cart: {
    cartItemSelector: '[data-cart-item]',
    cartRemoveSelector: 'cart-remove-button', 
    engravingServiceHandle: 'stethoscope-engraving',
    mainProductHandle: 'core-500-digital-stethoscope',
    propertyKeys: {
      engravingText: 'Engraving Text'
    }
  }
 };
 
 class CartManager {
  constructor() {
    logDebug('CartManager Constructor called');
    this.init();
  }
 
  init() {
    logDebug('CartManager Initializing');
    this.setupEventListeners();
  }
 
  setupEventListeners() {
    logDebug('Setting up event listeners');
    document.addEventListener('click', async (event) => {
      logDebug('Click event fired', event.target);
      const removeButton = event.target.closest(CART_CONFIG.cart.cartRemoveSelector);
      logDebug('Found remove button?', Boolean(removeButton));
      
      if (removeButton) {
        logDebug('Remove button clicked', removeButton);
        await this.handleCartItemRemoval(removeButton);
      }
    });
  }
 
  async handleCartItemRemoval(removeButton) {
    const cartItem = removeButton.closest(CART_CONFIG.cart.cartItemSelector);
    if (!cartItem) return;
 
    const handle = cartItem.dataset.handle;
    logDebug('Removing item with handle:', handle);
 
    // Only proceed if removing engraving service
    if (handle !== CART_CONFIG.cart.engravingServiceHandle) return;
 
    // Find product with engraving property
    const products = document.querySelectorAll(CART_CONFIG.cart.cartItemSelector);
    for (const item of products) {
      const rawProperties = item.dataset.properties;
      logDebug('Raw properties:', rawProperties);
      
      try {
        const properties = JSON.parse(rawProperties.replace(/&quot;/g, '"'));
        logDebug('Parsed properties:', properties);
 
        if (properties.length && properties[0][0] === CART_CONFIG.cart.propertyKeys.engravingText) {
          // Found main product with engraving
          const mainProductKey = item.dataset.key;
          if (!mainProductKey) continue;
 
          try {
            await this.updateCartItem(mainProductKey, {});
            await this.refreshCart();
            return;
          } catch (error) {
            logDebug('Error updating cart:', error);
          }
        }
      } catch (error) {
        logDebug('Error parsing properties:', error);
      }
    }
  }
 
  async updateCartItem(key, properties) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        properties: properties
      }),
    });
 
    if (!response.ok) {
      throw new Error('Failed to update cart item');
    }
 
    return response.json();
  }
 
  async refreshCart() {
    window.location.reload();
  }
 }
 
 const cartManager = new CartManager();
 
 document.addEventListener('DOMContentLoaded', () => {
  logDebug('DOMContentLoaded fired');
  logDebug('Remove buttons found:', document.querySelectorAll(CART_CONFIG.cart.cartRemoveSelector).length);
  logDebug('Cart items found:', document.querySelectorAll(CART_CONFIG.cart.cartItemSelector).length);
 });